import React from 'react';
import PropTypes from 'prop-types';
import { css, cx } from 'emotion';

import { breakpoints, colors, baselineGrid } from '../utils/presets';
import { toRem, fp } from '../utils/functions';

import InnerWrapper from '../components/inner-wrapper';
import AnimatedHeading from '../components/animated-heading';
import ThemePreview, {
  GhostPreview,
  TeaserPreview,
  themePreview,
} from '../components/theme-preview';

const padding = fp({
  paddingTop: [
    `${toRem(baselineGrid * 4)}`,
    `${toRem(baselineGrid * 4)}`,
    `${toRem(baselineGrid * 6)}`,
  ],
});

const themesGrid = css`
  background-color: ${colors.ui.bright};
  overflow: hidden;
`;

const themesGridPadded = css`
  ${padding};
`;

const gridSpacer = css`
  ${themePreview};
  height: 0;
  margin: 0 !important;
`;

const themesGridWrapper = css`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
`;

const themesHeadingWrapper = css``;

const ghostItem = css`
  @media (max-width: ${breakpoints.desk - 1}px) {
    display: none;
  }
`;

const teaserItem = css`
  @media (max-width: ${breakpoints.lap - 1}px) {
    display: none;
  }
`;

const ThemesGrid = ({
  themes,
  coloured,
  title,
  animatedTitle,
  titleWordsWrap,
  comingSoon,
  teaser,
  teaserLink,
  children,
}) => (
  <div css={cx(themesGrid, { [themesGridPadded]: !title })}>
    {children}
    {title && (
      <InnerWrapper className={themesHeadingWrapper}>
        <AnimatedHeading text={title} animated={animatedTitle} wrapWordsAfter={titleWordsWrap} />
      </InnerWrapper>
    )}
    <InnerWrapper className={themesGridWrapper}>
      {themes
        .sort((a, b) => a.node.fields.order - b.node.fields.order)
        .map(({ node }) => <ThemePreview key={node.id} theme={node} coloured={coloured} />)}
      {comingSoon && <GhostPreview className={ghostItem} />}
      {teaser && (
        <TeaserPreview className={teaserItem} teaser={'Browse all themes'} linkTo={teaserLink} />
      )}
      <div className={gridSpacer} />
      <div className={gridSpacer} />
    </InnerWrapper>
  </div>
);

ThemesGrid.propTypes = {
  themes: PropTypes.array.isRequired,
  coloured: PropTypes.bool,
  title: PropTypes.string,
  animatedTitle: PropTypes.bool,
  titleWordsWrap: PropTypes.number,
  comingSoon: PropTypes.bool,
  teaser: PropTypes.bool,
  teaserLink: PropTypes.string,
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
};

ThemesGrid.defaultProps = {
  coloured: false,
  animatedTitle: true,
};

export default ThemesGrid;



// WEBPACK FOOTER //
// ./src/components/themes-grid.js